class SiteHeader {
  constructor(root) {
    this.root = root;
    this.group = root.closest('[data-header-group]');
    this.drawer = root.querySelector('[data-header-drawer]');
    this.toggle = root.querySelector('[data-header-toggle]');
    this.closeButtons = root.querySelectorAll('[data-header-close]');
    this.isOverlay = this.group?.classList.contains('site-header-group--overlay');

    this.bind();
    this.bindScroll();
  }

  bind() {
    if (!this.toggle || !this.drawer) return;

    this.toggle.addEventListener('click', () => this.openDrawer());

    this.closeButtons.forEach((button) => {
      button.addEventListener('click', () => this.closeDrawer());
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.closeDrawer();
    });
  }

  bindScroll() {
    if (!this.isOverlay || !this.group) return;

    const onScroll = () => {
      if (window.scrollY > 48) {
        this.group.classList.add('is-scrolled');
      } else {
        this.group.classList.remove('is-scrolled');
      }
    };

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  openDrawer() {
    this.drawer.classList.add('is-open');
    this.drawer.setAttribute('aria-hidden', 'false');
    this.toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  closeDrawer() {
    this.drawer.classList.remove('is-open');
    this.drawer.setAttribute('aria-hidden', 'true');
    this.toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-site-header]').forEach((root) => {
    new SiteHeader(root);
  });
});
